import { render } from "./HeaderPC.vue?vue&type=template&id=01e1a4b2&scoped=true"
import script from "./HeaderPC.vue?vue&type=script&lang=js"
export * from "./HeaderPC.vue?vue&type=script&lang=js"

import "./HeaderPC.vue?vue&type=style&index=0&id=01e1a4b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e1a4b2"]])

export default __exports__